import type { ComponentType } from "react";
import { AccessRequestsToolUI } from "./AccessRequestsCard";
import type { ToolUIProps } from "./ToolUIContext";
import { CohortCreateToolUI, CohortGetToolUI, CohortUpdateToolUI } from "./cohort-tool-uis";

export const TOOL_UI_REGISTRY: Map<string, ComponentType<ToolUIProps>> = new Map([
  ["cohort_explorer_get_cohort", CohortGetToolUI],
  ["cohort_explorer_update_cohort", CohortUpdateToolUI],
  ["cohort_explorer_create_cohort", CohortCreateToolUI],
  ["cohort_explorer_get_access_requests", AccessRequestsToolUI],
]);
